config.$inject = ["$stateProvider", "$urlRouterProvider"];
export function config($stateProvider: ng.ui.IStateProvider, $urlRouterProvider: ng.ui.IUrlRouterProvider): void {
    $stateProvider
    .state("home", {
      url: "/",
      template: "<home-page></home-page>"
    })
    .state("dashboard", {
      url: "/dashboard",
      template: "<dashboard-page></dashboard-page>",
      resolve: {
        account: ['AccountService', (AccountService) => {
          return AccountService.$promise;
        }]
      }
    })
    .state("mydataset", {
      url: "/mydataset",
      template: "<my-dataset-page></my-dataset-page>",
      params: {
        processed: null,
        published: null,
        quality: null,
        type: null,
        private: null,
        internal: null,
        pending: null
      },
      resolve: {
        account: ['AccountService', (AccountService) => {
          return AccountService.$promise;
        }]
      }
    })
    .state("dataset", {
      url: "/dataset/:id",
      template: "<dataset-page></dataset-page>"
    })
    .state("dataview", {
      url: "/dataview/:id",
      template: "<dataview-page></dataview-page>"
    })
    .state("search", {
      url: "/search?q",
      params: {
        processed: null,
        published: null,
        quality: null,
        type: null,
        private: null,
        internal: null,
        pending: null
      },
      reloadOnSearch: false,
      template: "<search-page></search-page>"
    })
    .state("feedback", {
      url: "/feedback",
      template: "<feedback-page></feedback-page>"
    })
    .state("about", {
      url: "/about",
      template: "<about-page></about-page>"
    })
    .state("term", {
      url: "/term",
      template: "<term-page></term-page>"
    })
    .state("privacy", {
      url: "/privacy",
      template: "<privacy-page></privacy-page>"
    })
    .state("dataPolicy", {
      url: "/dataPolicy",
      template: "<policy-page></policy-page>"
    })
    .state("dataChampion", {
      url: "/dataChampion",
      template: "<champion-page></champion-page>"
    })
    .state("disclaimer", {
      url: "/disclaimer",
      template: "<disclaimer-page></disclaimer-page>"
    });
    $urlRouterProvider.otherwise("/");
}
